import React from 'lib/react';
import {
  EVPaper, EVGrid, EVSkeleton,
} from 'lib/components';
import { newEmptyArray } from 'utils/app.utils';
import TextAlertSettingsStyles from '../TextAlertSettingsStyles';

function TextAlertSettingsLoader() {
  const classes = TextAlertSettingsStyles();
  const skeleton1 = <EVSkeleton style={{ height: '40px', width: '100%', borderRadius: '6px' }} animation="wave" variant="rect" />;
  const skeleton2 = <EVSkeleton style={{ height: '30px', width: '60%', borderRadius: '6px' }} animation="wave" variant="rect" />;
  const skeleton3 = <EVSkeleton style={{ height: '20px', width: '100%', borderRadius: '6px' }} animation="wave" variant="rect" />;
  const skeleton4 = <EVSkeleton style={{ height: '30px', width: '100%', borderRadius: '6px' }} animation="wave" variant="rect" />;

  return (
    <EVGrid className={classes.textAlertSettingsContainer}>
      <EVPaper className={classes.textAlertSettingsPaper}>
        <EVGrid className={classes.textAlertPhoneContainer}>
          {skeleton2}
          <EVGrid className={classes.phoneInputContainer}>
            {newEmptyArray(2).map(() => skeleton1)}
          </EVGrid>
        </EVGrid>
        <EVGrid className={classes.textAlertMessageContainer}>
          {skeleton2}
          <EVGrid style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {newEmptyArray(4).map(() => skeleton1)}
          </EVGrid>
        </EVGrid>
        <EVGrid className={classes.textAlertDeliveryContainer}>
          {skeleton2}
          <EVGrid className={classes.deliveryStatusTypesContainer}>
            {newEmptyArray(2).map(() => skeleton1)}
          </EVGrid>
        </EVGrid>
        <EVGrid className={classes.messageAndButtonsContainer}>
          <EVGrid className={classes.carrierMessageContainer}>
            {newEmptyArray(2).map(() => skeleton3)}
          </EVGrid>
          <EVGrid className={classes.buttonsContainer}>
            {newEmptyArray(2).map(() => skeleton4)}
          </EVGrid>
        </EVGrid>
      </EVPaper>
    </EVGrid>
  );
}

export default TextAlertSettingsLoader;
